import { callAPI } from "./core";

async function listUsers(page, size, query) {
  let params = {
    page: page,
    size: size
  };
  if (query != null && query.length > 0) {
    params.query = query;
  }

  return await callAPI("/user", "GET", params, true);
}

async function createUser(user) {
  return await callAPI(`/user`, "POST", user, true);
}

async function getUser(userId) {
  return await callAPI(`/user/${userId}`, "GET", null, true);
}

async function updateUser(userId, updates) {
  return await callAPI(`/user/${userId}`, "PATCH", updates, true);
}

async function deleteUser(userId) {
  return await callAPI(`/user/${userId}`, "DELETE", null, true);
}

async function approveUser(userId) {
  return await callAPI(`/user/${userId}/approve`, "POST", null, true);
}

export { getUser, deleteUser, createUser, updateUser, listUsers, approveUser };
